export function isDistinctFinishNode(isLastNode: boolean, isStartNode: boolean): boolean {
  return isLastNode && !isStartNode
}
